// Capa anti-copia: disuade la copia casual del contenido sin afectar formularios,
// iframes (YouTube, calendario GHL), selector de país, scroll ni estados de foco.
// Nota: ninguna protección en el navegador es infalible; esto frena la copia casual.

const NOTICE = '© 2026 Chale Rodriguez. Contenido protegido. Prohibida su copia o reproducción.';
const STYLE_ID = 'protect-styles';
const FORM_FIELD = 'input, textarea, select, [contenteditable=""], [contenteditable="true"]';

const CSS = `
body { -webkit-user-select: none; user-select: none; -webkit-touch-callout: none; }
input, textarea, select, [contenteditable], [contenteditable] * {
  -webkit-user-select: text; user-select: text; -webkit-touch-callout: default;
}
img { -webkit-user-drag: none; user-drag: none; }
`;

function isFormField(target: EventTarget | null): boolean {
  return target instanceof Element && !!target.closest(FORM_FIELD);
}

function lockImages(root: ParentNode) {
  root.querySelectorAll('img').forEach((img) => img.setAttribute('draggable', 'false'));
}

let active = false;

export function protect(): () => void {
  if (active || typeof document === 'undefined') return () => {};
  active = true;

  // Estilos
  const style = document.createElement('style');
  style.id = STYLE_ID;
  style.textContent = CSS;
  document.head.appendChild(style);

  // Aviso oculto en el HTML + consola
  const comment = document.createComment(` ${NOTICE} `);
  document.body.insertBefore(comment, document.body.firstChild);
  // eslint-disable-next-line no-console
  console.log(`%c${NOTICE}`, 'color:#1F4BFF;font-weight:700;font-size:13px;');

  const onContextMenu = (e: MouseEvent) => {
    if (!isFormField(e.target)) e.preventDefault();
  };

  const onCopyCut = (e: ClipboardEvent) => {
    if (!isFormField(e.target)) e.preventDefault();
  };

  const onSelectStart = (e: Event) => {
    if (!isFormField(e.target)) e.preventDefault();
  };

  const onDragStart = (e: DragEvent) => {
    if (e.target instanceof HTMLImageElement) e.preventDefault();
  };

  const onKeyDown = (e: KeyboardEvent) => {
    const key = e.key.toLowerCase();
    const mod = e.ctrlKey || e.metaKey;
    const blocked =
      e.key === 'F12' ||
      (mod && e.shiftKey && (key === 'i' || key === 'j' || key === 'c')) ||
      (mod && !e.shiftKey && (key === 'u' || key === 's' || key === 'p'));
    if (blocked) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  document.addEventListener('contextmenu', onContextMenu);
  document.addEventListener('copy', onCopyCut);
  document.addEventListener('cut', onCopyCut);
  document.addEventListener('selectstart', onSelectStart);
  document.addEventListener('dragstart', onDragStart);
  document.addEventListener('keydown', onKeyDown, true);

  // draggable=false en todas las imágenes, incluidas las que se monten después
  lockImages(document);
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      m.addedNodes.forEach((node) => {
        if (node instanceof HTMLImageElement) node.setAttribute('draggable', 'false');
        else if (node instanceof Element) lockImages(node);
      });
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  return () => {
    active = false;
    observer.disconnect();
    document.removeEventListener('contextmenu', onContextMenu);
    document.removeEventListener('copy', onCopyCut);
    document.removeEventListener('cut', onCopyCut);
    document.removeEventListener('selectstart', onSelectStart);
    document.removeEventListener('dragstart', onDragStart);
    document.removeEventListener('keydown', onKeyDown, true);
    style.remove();
    comment.remove();
  };
}
